export default "__VITE_ASSET__GFm3CCxK__"